module.exports = __webpack_public_path__ + "img/limpiarFiltro.1b07978e.svg";